import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    header: {
      "& .MuiTypography-body2": {
        fontSize: "1.3em !important"
      }
    },
    avatar: {
      backgroundColor: "#1f8434"
    },
    tableWrapper: {
      padding: "0",
      margin: "0",
      "& .MuiPaper-outlined": {
        border: 0
      },
      "& .MuiTable-root": {
        "& .MuiTableRow-root": {
          "& .MuiTableCell-root": {
            "& .MuiTableSortLabel-root": {
              "&:hover": {
                color: "#bbdefb"
              }
            },
            "& .MuiTableSortLabel-active": {
              color: "#bbdefb",
              "& .MuiTableSortLabel-icon": {
                color: "#bbdefb"
              }
            }
          }
        }
      }
    }
  })
);
